import { render } from "./HomeNoticias.vue?vue&type=template&id=5aa0c915&scoped=true"
import script from "./HomeNoticias.vue?vue&type=script&lang=js"
export * from "./HomeNoticias.vue?vue&type=script&lang=js"

import "./HomeNoticias.vue?vue&type=style&index=0&id=5aa0c915&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa0c915"]])

export default __exports__